/* ROME v5 – cart drawer, quick add, print-position toggle, local-currency texts, email popup (off since v26), v26 size sheet */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var cur = (window.Shopify && Shopify.currency) || { active: 'EUR', rate: '1.0' };
  var rate = parseFloat(cur.rate) || 1;
  var lang = document.documentElement.lang || 'en';
  var FREE_QTY = 2; /* free shipping from 2 items (automatic discount) */

  function fmt(amount, decimals) {
    try {
      return new Intl.NumberFormat(lang, { style: 'currency', currency: cur.active, minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(amount);
    } catch (e) { return amount.toFixed(decimals) + ' ' + cur.active; }
  }

  /* ---------- Euro amounts in theme texts -> visitor currency ---------- */
  function localiseText(root) {
    if (cur.active === 'EUR') return;
    var walker = document.createTreeWalker(root || document.body, NodeFilter.SHOW_TEXT, null);
    var nodes = [];
    while (walker.nextNode()) { if (/€\s?\d/.test(walker.currentNode.nodeValue)) nodes.push(walker.currentNode); }
    nodes.forEach(function (n) {
      if (n.parentNode && /^(SCRIPT|STYLE|TEXTAREA)$/.test(n.parentNode.nodeName)) return;
      n.nodeValue = n.nodeValue.replace(/€\s?(\d+(?:[.,]\d{1,2})?)/g, function (m, v) {
        var eur = parseFloat(v.replace(',', '.'));
        var whole = Math.round(eur) === eur;
        var conv = eur * rate;
        return whole ? fmt(Math.ceil(conv), 0) : fmt(conv, 2);
      });
    });
  }

  /* ---------- Cart drawer ---------- */
  var drawerSel = '[data-cart-drawer]';
  function openDrawer() {
    var d = $(drawerSel); if (!d) return;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); document.documentElement.classList.add('no-scroll');
  }
  function closeDrawer() {
    var d = $(drawerSel); if (!d) return;
    d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); document.documentElement.classList.remove('no-scroll');
  }
  function updateFreeShip() {
    var box = $('[data-free-ship]'); if (!box) return;
    var count = parseInt(box.getAttribute('data-count'), 10) || 0;
    var left = FREE_QTY - count;
    var txt = $('[data-free-ship-text]', box), bar = $('[data-free-ship-bar]', box);
    if (left <= 0) { txt.innerHTML = '<strong>Free shipping unlocked</strong>'; bar.style.width = '100%'; }
    else if (count === 0) { txt.innerHTML = '<strong>Free shipping</strong> on 2+ items'; bar.style.width = '4%'; }
    else { txt.innerHTML = 'Add <strong>' + left + ' more ' + (left === 1 ? 'item' : 'items') + '</strong> for free shipping'; bar.style.width = Math.max(4, Math.round(count / FREE_QTY * 100)) + '%'; }
  }
  function renderDrawer(html, open) {
    var tmp = document.createElement('div'); tmp.innerHTML = html;
    var fresh = $(drawerSel, tmp), old = $(drawerSel);
    if (fresh && old) {
      var wasOpen = old.classList.contains('is-open') || open;
      old.parentNode.replaceChild(fresh, old);
      if (wasOpen) { fresh.classList.add('is-open'); fresh.setAttribute('aria-hidden', 'false'); }
    }
    updateFreeShip(); localiseText($(drawerSel)); bindDrawer(); updateCounts();
  }
  function refresh(open) {
    return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (j) { renderDrawer(j['cart-drawer'], open); });
  }
  function updateCounts() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      $$('.cart-count').forEach(function (el) { el.textContent = c.item_count; el.hidden = c.item_count === 0; });
      var hdr = $('[data-cart-icon]');
      if (hdr && c.item_count > 0 && !$('.cart-count', hdr)) { var s = document.createElement('span'); s.className = 'cart-count'; s.textContent = c.item_count; hdr.appendChild(s); }
      var bar = $('[data-bundle-bar]'), bt = $('[data-bundle-text]');
      if (bar) bar.style.width = Math.min(100, Math.round(c.item_count / 3 * 100)) + '%';
      if (bt) bt.textContent = c.item_count >= 3 ? '10% off unlocked – applied automatically at checkout.' : (3 - c.item_count) + ' more ' + (c.item_count === 2 ? 'item' : 'items') + ' to unlock 10% off – applied automatically.';
    });
  }
  function addItem(id, qty, btn) {
    if (btn) { btn.disabled = true; btn.setAttribute('data-busy', ''); }
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: qty || 1 }] }) })
      .then(function (r) { if (!r.ok) throw r; return refresh(true); })
      .catch(function () { window.location.href = '/cart'; })
      .finally(function () { if (btn) { btn.disabled = false; btn.removeAttribute('data-busy'); } rwCloseSheet(); });
  }
  function bindDrawer() {
    $$('[data-cart-close]').forEach(function (b) { b.onclick = closeDrawer; });
    $$('[data-cart-drawer] [data-line]').forEach(function (b) {
      b.onclick = function () {
        fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: Number(b.getAttribute('data-line')), quantity: Number(b.getAttribute('data-qty')) }) })
          .then(function () { return refresh(true); });
      };
    });
    bindQuickAdd($(drawerSel));
  }
  function bindQuickAdd(root) {
    $$('[data-quick-add]', root).forEach(function (f) {
      if (f._bound) return; f._bound = true;
      f.addEventListener('submit', function (e) {
        e.preventDefault();
        var sel = f.elements.id;
        if (!sel.value) { sel.classList.add('is-need'); sel.focus(); try { if (sel.showPicker) sel.showPicker(); } catch (x) {} return; }
        addItem(sel.value, 1, $('button', f));
      });
    });
    rwPresetQuick(root);
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
  $$('[data-cart-icon]').forEach(function (a) { a.addEventListener('click', function (e) { e.preventDefault(); openDrawer(); }); });

  /* Product form -> AJAX add + drawer (rome.js still handles size selection & validation) */
  var form = $('[data-product-form]');
  if (form) {
    form.addEventListener('submit', function (e) {
      var id = form.querySelector('[data-variant-id]').value;
      if (!id || e.defaultPrevented) return;
      e.preventDefault();
      addItem(id, 1, form.querySelector('[data-atc]'));
    });
  }

  /* ---------- Print position toggle (front / back product pair) ---------- */
  var toggle = $('[data-print-toggle]');
  if (toggle) {
    var vars = {};
    $$('[data-print-variants]', toggle).forEach(function (s) { try { vars[s.getAttribute('data-print-variants')] = JSON.parse(s.textContent); } catch (e) {} });
    $$('[data-print-link]', toggle).forEach(function (a) {
      a.addEventListener('click', function (e) {
        if (a.classList.contains('is-selected')) { e.preventDefault(); return; }
        var target = vars[a.getAttribute('data-print-link')] || [];
        var chosen = [];
        $$('[data-choices]').forEach(function (g) { var s = g.querySelector('.is-selected'); chosen[+g.getAttribute('data-opt-index') || 0] = s ? s.getAttribute('data-value') : null; });
        var best = null;
        target.forEach(function (v) {
          var score = 0;
          v.options.forEach(function (o, i) { if (chosen[i] && chosen[i] === o) score++; });
          if (!best || score > best.score) best = { v: v, score: score };
        });
        if (best && best.score > 0) { e.preventDefault(); window.location.href = a.getAttribute('href') + '?variant=' + best.v.id; }
      });
    });
  }

  /* Shirt pictograms follow the chosen colour */
  function paintShirts() {
    var t = $('[data-print-toggle]'); if (!t) return;
    var sel = $('[data-kind="color"] .is-selected');
    var c = sel ? (sel.getAttribute('data-value') || '').toLowerCase() : 'white';
    t.setAttribute('data-shirt', /black|dark|navy|charcoal/.test(c) ? 'dark' : 'light');
  }
  $$('[data-kind="color"] [data-value]').forEach(function (b) { b.addEventListener('click', paintShirts); });
  paintShirts();

  /* ---------- Email popup (10% first order) ---------- */
  var pop = $('[data-popup]');
  function store(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }
  if (pop && !store('rw_popup') && !/\/(cart|checkout|pages\/(withdrawal|legal|privacy|terms))/.test(location.pathname)) {
    var shown = false;
    var show = function () { if (shown) return; shown = true; pop.hidden = false; store('rw_popup', String(Date.now())); };
    setTimeout(show, 15000);
    document.addEventListener('mouseout', function (e) { if (!e.relatedTarget && e.clientY < 10) show(); });
  }
  $$('[data-popup-close]').forEach(function (b) { b.addEventListener('click', function () { pop.hidden = true; }); });
  var pf = $('[data-popup-form]');
  if (pf) {
    pf.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = pf.querySelector('button'); btn.disabled = true;
      fetch('/contact', { method: 'POST', body: new FormData(pf) }).finally(function () {
        pf.hidden = true; $('[data-popup-done]').hidden = false;
      });
    });
  }

  /* ---------- v26: size sheet for the sticky bar (mobile) and the "+" on product cards ---------- */
  var rwSheetEl = null, rwSheetOpts = null, rwSheetFocus = null;
  function rwEsc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function rwCloseSheet() {
    if (!rwSheetEl || !rwSheetEl.classList.contains('is-open')) return;
    rwSheetEl.classList.remove('is-open'); rwSheetEl.setAttribute('aria-hidden', 'true');
    if (!$(drawerSel + '.is-open')) document.documentElement.classList.remove('no-scroll');
    if (rwSheetFocus && rwSheetFocus.focus) { try { rwSheetFocus.focus({ preventScroll: true }); } catch (e) {} }
    rwSheetFocus = null;
  }
  function rwRenderSheet(o) {
    var html = '<div class="rw-sheet__head">' + (o.img ? '<img src="' + rwEsc(o.img) + '" alt="" width="68" height="68">' : '') + '<div><div class="rw-sheet__title">' + rwEsc(o.title) + '</div><div class="rw-sheet__price">' + rwEsc(o.price) + '</div></div></div>';
    if (o.print && o.print.length) {
      html += '<div class="rw-sheet__print">' + o.print.map(function (p, i) {
        return '<a href="' + rwEsc(p.href) + '" data-rw-print="' + i + '"' + (p.on ? ' class="is-on" aria-current="true"' : '') + '>' + rwEsc(p.label) + (p.extra ? ' <em>' + rwEsc(p.extra) + '</em>' : '') + '</a>';
      }).join('') + '</div>';
    }
    if (o.colors && o.colors.length > 1) {
      html += '<div class="rw-sheet__colors">' + o.colors.map(function (c) {
        return '<button type="button" data-rw-color="' + rwEsc(c.label) + '"' + (c.on ? ' class="is-on" aria-pressed="true"' : ' aria-pressed="false"') + (c.available === false ? ' disabled' : '') + '>' + rwEsc(c.label) + '</button>';
      }).join('') + '</div>';
    }
    html += '<div class="rw-sheet__label"><span>Tap your size to add to cart</span>' + (o.side ? (o.side.href ? '<a href="' + rwEsc(o.side.href) + '">' + rwEsc(o.side.label) + '</a>' : '<button type="button" data-rw-side>' + rwEsc(o.side.label) + '</button>') : '') + '</div>';
    html += '<div class="rw-sheet__sizes">' + o.sizes.map(function (s) {
      return '<button type="button" data-rw-size="' + rwEsc(s.label) + '"' + (s.available === false ? ' disabled' : '') + (s.mine ? ' class="is-mine"' : '') + '>' + rwEsc(s.label) + '</button>';
    }).join('') + '</div>';
    if (o.note) html += '<p class="rw-sheet__note">' + rwEsc(o.note) + '</p>';
    $('[data-rw-body]', rwSheetEl).innerHTML = html;
    localiseText(rwSheetEl);
  }
  function rwOpenSheet(o) {
    if (!rwSheetEl) {
      rwSheetEl = document.createElement('div');
      rwSheetEl.className = 'rw-sheet'; rwSheetEl.setAttribute('aria-hidden', 'true');
      rwSheetEl.innerHTML = '<div class="rw-sheet__bg" data-rw-close></div><div class="rw-sheet__panel" role="dialog" aria-modal="true" aria-label="Choose your size" tabindex="-1"><button type="button" class="rw-sheet__x" data-rw-close aria-label="Close">&times;</button><div data-rw-body></div></div>';
      document.body.appendChild(rwSheetEl);
      rwSheetEl.addEventListener('click', function (e) {
        var t = e.target;
        if (t.hasAttribute('data-rw-close')) { rwCloseSheet(); return; }
        var o2 = rwSheetOpts; if (!o2) return;
        var size = t.getAttribute('data-rw-size');
        if (size !== null) { if (t.disabled) return; t.classList.add('is-busy'); try { localStorage.setItem('rome_size', size); } catch (x) {} o2.onSize(size); return; }
        var color = t.getAttribute('data-rw-color');
        if (color !== null) { o2.onColor(color); rwOpenSheet(o2.refresh ? o2.refresh() : o2); return; }
        if (t.hasAttribute('data-rw-side') && o2.side && o2.side.action) { o2.side.action(); return; }
        if (t.closest('[data-rw-print]') && o2.onPrint) { e.preventDefault(); o2.onPrint(+t.closest('[data-rw-print]').getAttribute('data-rw-print')); }
      });
    }
    rwSheetOpts = o;
    rwRenderSheet(o);
    if (!rwSheetEl.classList.contains('is-open')) { rwSheetFocus = document.activeElement; }
    rwSheetEl.classList.add('is-open'); rwSheetEl.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('no-scroll');
    try { $('.rw-sheet__panel', rwSheetEl).focus({ preventScroll: true }); } catch (e) {}
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') rwCloseSheet(); });

  /* product page: built from the real buttons, so the add-to-cart path stays exactly the same */
  function rwPdpSheet() {
    var f = $('[data-product-form]'); if (!f) return null;
    var atc = $('[data-atc]', f);
    var sizeBtns = $$('[data-kind="size"] [data-value]', f);
    var colorBtns = $$('[data-kind="color"] [data-value]', f);
    var mine = store('rome_size');
    var gimg = $('.pp-gallery__item img') || $('[data-gallery] img');
    var sticky = $('[data-sticky-price]');
    var chartBtn = $('.pp-chart-btn', f);
    var fit = $('.pp-fit', f);
    var links = $$('[data-print-link]', f);
    var o = {
      title: (($('.pp-title') || {}).textContent || '').split(' – ')[0].trim(),
      price: sticky ? sticky.textContent.trim() : '',
      img: gimg ? (gimg.currentSrc || gimg.src) : '',
      print: links.map(function (a) {
        var back = a.getAttribute('data-print-link') === 'back', em = $('em', a), txt = em ? em.textContent.trim() : '';
        return { label: back ? 'Back print' : 'Front print', extra: txt.charAt(0) === '+' ? txt : '', href: a.getAttribute('href'), on: a.classList.contains('is-selected') };
      }),
      colors: colorBtns.map(function (b) { return { label: b.getAttribute('data-value'), on: b.classList.contains('is-selected'), available: !b.classList.contains('is-unavailable') }; }),
      sizes: sizeBtns.map(function (b) { var v = b.getAttribute('data-value'); return { label: v, available: !b.classList.contains('is-unavailable'), mine: v === mine }; }),
      side: chartBtn ? { label: 'Size guide', action: function () { chartBtn.click(); } } : null,
      note: ((fit ? fit.textContent.trim() : 'Unisex fit.') + ' Free shipping on 2+ items').replace(/\.\s+Free/, ' · Free'),
      onSize: function (v) {
        var real = sizeBtns.filter(function (b) { return b.getAttribute('data-value') === v; })[0];
        if (real) real.click();
        if (atc) atc.click();
        window.setTimeout(rwCloseSheet, 2500); /* normally closed by addItem */
      },
      onColor: function (v) { var real = colorBtns.filter(function (b) { return b.getAttribute('data-value') === v; })[0]; if (real) real.click(); },
      onPrint: function (i) {
        var a = links[i]; if (!a || a.classList.contains('is-selected')) return;
        window.location.href = a.getAttribute('href') + '#rw-size';
      },
      refresh: rwPdpSheet
    };
    return o;
  }
  window.rwSizeSheet = function () { var o = rwPdpSheet(); if (o && o.sizes.length) { rwOpenSheet(o); return true; } return false; };
  if (window.location.hash === '#rw-size' && $('[data-sticky]')) {
    window.setTimeout(function () { if (window.matchMedia('(max-width:900px)').matches) window.rwSizeSheet(); }, 300);
  }

  /* "+" on product cards: size sheet without leaving the page */
  var rwProducts = {};
  function rwLoadProduct(h) {
    if (!rwProducts[h]) rwProducts[h] = fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { if (!r.ok) throw r; return r.json(); });
    return rwProducts[h];
  }
  function rwCardSheet(card, p, color) {
    var names = (p.options || []).map(function (o) { return String(o.name || o).toLowerCase(); });
    var si = names.indexOf('size'), ci = names.indexOf('color'); if (ci < 0) ci = names.indexOf('colour');
    var colors = ci >= 0 ? p.options[ci].values : [];
    var firstOk = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
    var col = color || (ci >= 0 ? firstOk.options[ci] : null);
    var inColor = p.variants.filter(function (v) { return ci < 0 || v.options[ci] === col; });
    var mine = store('rome_size');
    var img = $('.card__track img', card) || $('img', card);
    var priceEl = $('.card__price', card);
    return {
      title: String(p.title).split(' | ')[0].split(' – ')[0].trim(),
      price: priceEl ? priceEl.childNodes[0].textContent.trim() : '',
      img: img ? (img.currentSrc || img.src) : '',
      colors: colors.map(function (c) { return { label: c, on: c === col }; }),
      sizes: inColor.map(function (v) { var l = si >= 0 ? v.options[si] : v.title; return { label: l, available: v.available, mine: l === mine }; }),
      side: { label: 'View product', href: card.getAttribute('href') },
      note: 'Unisex fit – true to size · Free shipping on 2+ items',
      onSize: function (l) {
        var v = inColor.filter(function (x) { return (si >= 0 ? x.options[si] : x.title) === l; })[0];
        if (v) addItem(v.id, 1);
      },
      onColor: function (c) { col = c; },
      refresh: function () { return rwCardSheet(card, p, col); }
    };
  }
  function rwPlus(el) {
    var card = el.closest('a'); if (!card || el.hasAttribute('data-busy')) return;
    el.setAttribute('data-busy', '');
    rwLoadProduct(el.getAttribute('data-rw-plus')).then(function (p) {
      rwOpenSheet(rwCardSheet(card, p));
    }).catch(function () { window.location.href = card.getAttribute('href'); }).finally(function () { el.removeAttribute('data-busy'); });
  }
  document.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest('[data-rw-plus]');
    if (!el) return;
    e.preventDefault(); e.stopPropagation();
    rwPlus(el);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var el = e.target.closest && e.target.closest('[data-rw-plus]');
    if (!el) return;
    e.preventDefault(); e.stopPropagation();
    rwPlus(el);
  });

  /* quick-add rows: take over the chosen / remembered size */
  function rwPresetQuick(root, force) {
    var mine = store('rome_size'); if (!mine) return;
    $$('[data-quick-add] select', root).forEach(function (s) {
      if (s._touched || (s.value && !force)) return;
      var hit = Array.prototype.slice.call(s.options).filter(function (o) { return o.text.trim() === mine; })[0];
      if (hit) s.value = hit.value;
    });
  }
  document.addEventListener('change', function (e) {
    var s = e.target; if (!s.closest || !s.closest('[data-quick-add]') || s.tagName !== 'SELECT') return;
    s._touched = true; s.classList.remove('is-need');
    var o = s.options[s.selectedIndex];
    if (o && o.value) { try { localStorage.setItem('rome_size', o.text.trim()); } catch (x) {} }
  });
  $$('[data-kind="size"] [data-value]').forEach(function (b) { b.addEventListener('click', function () { rwPresetQuick(document, true); }); });
  rwPresetQuick(document);
  if ($('[data-sticky]')) document.documentElement.classList.add('rw-has-bar');

  /* init */
  updateFreeShip();
  localiseText(document.body);
  bindDrawer();
  bindQuickAdd(document);
})();
